export default {
  search: 'Шукати сторінку',
  create: 'Створіти сторінку',
  delete: 'Видалити'
};
